
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press-kit",
      function () {
        return require("private-next-pages/press-kit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press-kit"])
      });
    }
  